<template>
  <section id="about">
    <div class="hero-image">
      <img src="../../static/static-css/img/about-us/about.jpg" alt />
      <div class="overlay"></div>
    </div>
    <div class="dasboard-content">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="tittle">
              <h3>Website terms and conditions of sale</h3>
            </div>
            <div class="content">
              <p>
                <strong>
                  Please read the following important terms and conditions before you buy anything on our website and check that they contain everything which you want and nothing that you are not willing to agree to.
                </strong>
              </p>
              <p>
                This contract sets out:
              </p>
              <ul>
                <li>
                  <p>
                    Your legal rights and responsibilities.
                  </p>
                </li>
                <li>
                  <p>
                    our legal rights and responsibilities; and
                  </p>
                </li>
                <li>
                  <p>
                    certain key information required by law.
                  </p>
                </li>
              </ul>
              <p>
                In this contract:
              </p>
              <ul>
                <li>
                  <h6 class="definition-heading">
                    We, us or our
                  </h6>
                  <p>
                    means owner of the website: <a href="http://www.fintransformer.com">www.fintransformer.com</a>
                    <br>
                    References to us in these Terms also includes any group companies which we may have from time to time.
                  </p>
                </li>
                <li>
                  <h6 class="definition-heading">
                    Our site or our website
                  </h6>
                  <p>
                    refers to the site on which these terms and conditions are displayed, including, but not limited to the following websites:
                  </p>
                  <ul class="mb-4">
                    <li>
                      <p class="mb-0"><a href="http://www.fintransformer.com">www.fintransformer.com</a></p>
                    </li>
                    <!-- <br> -->
                    <li>
                      <p class="mb-0"><a href="http://www.fintransformer.de">www.fintransformer.de</a></p>
                    </li>
                    <!-- <br> -->
                    <li>
                      <p class="mb-0"><a href="http://www.fintransformer.co.uk">www.fintransformer.co.uk</a></p>
                    </li>

                  </ul>
                </li>
                <li>
                  <h6 class="definition-heading">
                    Our site or our website
                  </h6>
                  <p>
                    means the person accessing or using our site to make purchases from us.
                  </p>
                </li>
              </ul>

              <p>
                <strong>
                  Who we are
                </strong>
              </p>
              <p>
                Our office is at:
              </p>
              <p class="text-primary">
                P. O. Box 1400, Dubai, United Arab Emirates.
              </p>
              <p>
                The details of this contract will not be filed with any relevant authority by us.
              </p>
            </div>
            <div class="tittle mt-4">
              <h3>Terms and Conditions of Sale</h3>
            </div>
            <div class="content">
              <h5 class="content-heading">Introduction</h5>
              <ol>
                <li>
                  <p>
                    These terms and conditions apply to any sale of products, services or digital content on our site. If you buy products, services or digital content on our site you agree to be legally bound by this contract and the terms and conditions contained herein.
                  </p>
                </li>
                <li>
                  <p>
                    This contract is only available in English. No other languages are available for this contract.
                  </p>
                </li>
                <li>
                  <p>
                    When buying any products, services or digital content on our site you also agree to be bound by:
                  </p>
                  <ol style="list-style-type: lower-alpha;">
                    <li>
                      <p>
                         Our terms and conditions of use and any documents referred to therein
                      </p>
                    </li>
                    <li>
                      <p>
                        Our subscription terms and conditions if you are a subscriber
                      </p>
                    </li>
                    <li>
                      <p>
                        Extra terms which may add to, or replace some of, this contract. This may happen for the following reasons:
                      </p>
                      <ol class="" style="list-style-type: lower-roman;">
                        <li><p class="mb-0">Circumstances change for reasons outside our control</p></li>
                        <!-- <br> -->
                        <li><p class="mb-0">Legal or regulatory requirements</p></li>
                        <!-- <br> -->
                        <li><p class="mb-0">Change or modification in products or services.</p></li>
                      </ol>
                      <p>All these documents form part of this contract as though set out in full here.</p>
                    </li>
                  </ol>
                </li>
              </ol>
              <h5 class="content-heading">
                Information we give you
              </h5>
              <ol>
                <li>
                  <p>By law, we must give you certain key information before a legally binding contract between you and us is made. If you want to see this key information, please:</p>
                  <ol style="list-style-type: lower-alpha;">
                    <li>
                      <p>
                        Read the Confirmation email that will be sent to you when you have ordered services or digital content (see clause below); or
                      </p>
                    </li>
                    <li>
                      <p>
                        Contact us using the contact details at the top of this page or on the website
                      </p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p>
                    The key information we give you by law forms part of this contract (as though it is set out in full here).
                  </p>
                </li>
                <li>
                  <p>
                     If we have to change any key information once a legally binding contract between you and us is made, we can only do this if you agree to it.
                  </p>
                </li>
                <li>
                  <p>
                    You may not scan, probe or test the vulnerability of the Site or any network connected to the Site, nor breach the security or authentication measures on the Site or any network connected to the Site.
                  </p>
                </li>
              </ol>
              <h5 class="content-heading">
                Ordering from us
              </h5>
              <ol>
                <li>
                  <p>
                    Here we set out how a legally binding contract between you and us is made.
                  </p>
                </li>
                <li>
                  <p>
                    You place an order on our site by doing the following:
                  </p>
                  <p>
                    create a user profile
                    <br>
                    select a pricing option
                    <br>
                    enter required data
                    <br>
                    confirm order.
                  </p>
                </li>
                <li>
                  <p>
                    Please read and check your order carefully before submitting it. However, if you need to correct any errors you can do so before submitting it to us.
                  </p>
                </li>
                <li>
                  <p>
                    Before you place any order for digital content you must check that the hardware and software requirements of your computer or device mean that you can view or download the digital content. If required please contact us for assistance.
                  </p>
                </li>
                <li>
                  <p>
                    When you place your order at the end of the online checkout process (e.g. when you confirm payment), we may show a confirmation on the website or acknowledge it by email. This acknowledgement does not, however, mean that your order has been accepted.
                  </p>
                </li>
                <li>
                  <p>
                    We may contact you to say that we do not accept your order. This is typically for the following reasons:
                  </p>
                  <ol style="list-style-type: lower-alpha;">
                    <li>
                      <p>
                         The services or digital content are unavailable;
                      </p>
                    </li>
                    <li>
                      <p>
                        We cannot authorise your payment
                      </p>
                    </li>
                    <li>
                      <p>
                        You are not allowed to buy the services or digital content from us;
                      </p>
                    </li>
                    <li>
                      <p>
                        We are not allowed to sell the services or digital content to you;
                      </p>
                    </li>
                    <li>
                      <p>
                        The number of services or digital content you have ordered is too large; or
                      </p>
                    </li>
                    <li>
                      <p>
                        There has been a mistake on the pricing or description of the services or digital content.
                      </p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p>
                    We will only accept your order when we confirm the order on our site or send you an email to confirm this (Confirmation Email). At this point:
                  </p>
                  <ol style="list-style-type: lower-alpha;">
                    <li>
                      <p>
                        A legally binding contract will be in place between you and us; and
                      </p>
                    </li>
                    <li>
                      <p>
                        Your order will be fulfilled and your content will be available for viewing or download.
                      </p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p>
                    If you are under the age of 18 you may not buy any products, services or digital content from our site. However, in some cases you may not be able to buy certain products, services or digital content because you are too young. If so, this will be set out on the relevant webpage for the services or digital content concerned.
                  </p>
                </li>
              </ol>
              <h5 class="content-heading">
                Right to cancel this contract
              </h5>
              <ol>
                <li>
                  <p>
                    You have the right to cancel this contract within 24 hours without giving any reason.
                  </p>
                </li>
                <li>
                  <p>
                    However, this right to cancel will not apply to orders which have been partially or fully fulfilled i.e. a translation has been partially or fully generated.
                  </p>
                </li>
                <li>
                  <p>
                    The cancellation period will expire after 24 hours from the day on which this this contract was entered into.
                  </p>
                </li>
                <li>
                  <p>
                    To exercise the right to cancel, you must inform us of your decision to cancel this contract by a clear statement (e.g. a letter sent by post or email).
                  </p>
                </li>
                <li>
                  <p>
                    To meet the cancellation deadline, it is sufficient for you to send your communication concerning your exercise of the right to cancel before the cancellation period has expired.
                  </p>
                </li>
              </ol>
              <h5 class="content-heading">
                No right to cancel this contract once digital output has been generated or once downloading of any purchased digital content starts
              </h5>
              <p>
                When you buy the digital content you have no right to cancel this contract once the downloading of it starts or once a digital output (translation) has been generated.
              </p>
              <h5 class="content-heading">
                Payment and right to cancel if performance of services requested to commence before expiry of 24-hour cancellation period
              </h5>
              <ol>
                <li>
                  <p>
                    If you request us to begin the performance of services during the 24-hour cancellation period referred to above in the clause entitled "Right to cancel this contract ", you shall pay us an amount which is in proportion to what has been performed until the date when you have communicated to us your cancellation of this contract, in comparison with the full coverage of the contract.
                  </p>
                </li>
                <li>
                  <p>
                    You will lose the right to cancel this contract if the services have been fully performed at your express request within the cancellation period (in which case we will ask you to confirm that you understand you will lose your right to cancel).
                  </p>
                </li>
              </ol>
              <h5 class="content-heading">
                Effects of cancellation
              </h5>
              <ol>
                <li>
                  <p>
                     If you cancel this contract in accordance with these terms and conditions, we will reimburse to you all payments received from you.
                  </p>
                </li>
                <li>
                  <p>
                    We may make a deduction from the reimbursement for the value of any products or services delivered or supplied to you.
                  </p>
                </li>
                <li>
                  <p>
                    We will make the reimbursement without undue delay, and not later than:
                  </p>
                  <ol style="list-style-type: lower-alpha;">
                    <li>
                      <p>
                        30 days after the day we received your cancellation or
                      </p>
                    </li>
                    <li>
                      <p>
                         (if earlier) 30 days after the day you provide evidence that you have cancelled or
                      </p>
                    </li>
                    <li>
                      <p>
                         if there were no products or services supplied, 30 days after the day on which we are informed about your decision to cancel this contract.
                      </p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p>
                     We will make the reimbursement using the same means of payment as you used for the initial transaction, unless you have expressly agreed otherwise; in any event, you will not incur any fees as a result of the reimbursement.
                  </p>
                </li>
              </ol>
              <h5 class="content-heading">
                Download of digital content
              </h5>
              <ol>
                <li>
                  <p>
                    Once you have paid for your order and received the confirmation on the site or by email you will be given the option to view or download the digital content.
                  </p>
                </li>
                <li>
                  <p>
                    We may show or deliver your digital content in instalments. If you have any queries as to whether this is the case please consult the information provided at the time of purchase or contact us for further information.
                  </p>
                </li>
                <li>
                  <p>
                    If something happens which:
                  </p>
                  <ol style="list-style-type: lower-alpha;">
                    <li>
                      <p>
                        Is outside of our control and
                      </p>
                    </li>
                    <li>
                      <p>
                        Affects you being able to view or download the digital content;
                      </p>
                    </li>
                  </ol>
                  <p>
                    We will make the digital content available for view and download as soon as we can.
                  </p>
                </li>
              </ol>
              <h5 class="content-heading">
                Permission to use digital content
              </h5>
              <ol>
                <li>
                  <p>
                    When you buy any digital content and view or download it, you will own it.
                  </p>
                </li>
                <li>
                  <p>
                     The digital content:
                  </p>
                  <ol style="list-style-type: lower-alpha;">
                    <li>
                      <p>
                        Is personal to you. You can use it wherever you want in the world but only if you comply with local laws.
                      </p>
                    </li>
                    <li>
                      <p>
                        Is non-exclusive to you. We may supply the same or similar digital content to other users
                      </p>
                    </li>
                    <li>
                      <p>
                        May not be:
                      </p>
                      <ol style="list-style-type: lower-roman;">
                        <li>
                          <p>
                            Copied by you except for a reasonable number of necessary back-ups
                          </p>
                        </li>
                        <li>
                          <p>
                            Changed by you (which means, in particular, that you are not allowed to adapt, reverse-engineer or decompile it, or try to extract the source code from it, except where any of this is allowed by law).
                          </p>
                        </li>
                        <li>
                          <p>
                            Distributed or sold by you to any third party.
                          </p>
                        </li>
                      </ol>
                    </li>
                  </ol>
                </li>
                <li>
                      <p>
                        Except where you have permission to use the digital content under this clause, you will not obtain any rights of ownership or other rights (of whatever nature) in the digital content or in any copies of it.
                      </p>
                </li>
              </ol>
              <h5 class="content-heading">
                Performance of Services
              </h5>
              <ol>
                <li>
                  <p>
                    We will seek to perform the services purchased within a reasonable time and without causing you significant inconvenience.
                  </p>
                </li>
                <li>
                  <p>
                    If you have any questions as regards the time or date for performance of purchased services please contact us immediately.
                  </p>
                </li>
              </ol>
              <h5 class="content-heading">
                Payment
              </h5>
              <ol>
                <li>
                  <p>
                    We accept the following means of payment:
                  </p>
                  <p>
                    Credit Card
                    <br>
                    PayPal
                    <br>
                    Other Payment Processing Platforms
                  </p>
                </li>
                <li>
                  <p>
                    We will do all that we reasonably can to ensure that all of the information you give us when paying for services or digital content is secure by using an encrypted and secure payment mechanism. However, in the absence of negligence on our part we will not be legally responsible to you for any loss that you may suffer if a third party gains unauthorised access to any information that you give us.
                  </p>
                </li>
                <li>
                  <p>
                    Your credit card or debit card will only be charged when you confirm your order.
                  </p>
                </li>
                <li>
                  <p>
                    All payments by credit card or debit card need to be authorised by the relevant card issuer. From time to time we may also use extra security steps via Verified by Visa, Mastercard®SecureCodeTM or equivalent services.
                  </p>
                </li>
                <li>
                  <p>
                    If your payment is not received by us and you have already viewed or received any digital content, products or services, you must pay for such digital content, products or services within 7 days.
                  </p>
                </li>
                <li>
                  <p>
                     The price of the products, services or digital content is in united states dollars ($)(USD).
                  </p>
                </li>
                <li>
                  <p>
                    If you are a subscriber, and are completing a purchase which qualifies under the subscription, you will need to confirm the required information to qualify for any subscription benefits during the online checkout process. Please note that not all purchases may qualify for the subscription (please consult the subscription terms and conditions and Frequently Asked Questions for further information).
                  </p>
                </li>
              </ol>
              <h5 class="content-heading">
                Nature of digital content
              </h5>
              <ol>
                <li>
                  <p>
                    You have certain legal rights (also known as 'statutory rights'), for example, that the digital content:
                  </p>
                  <ol style="list-style-type: lower-alpha;">
                    <li>
                      <p>
                        Is of satisfactory quality and
                      </p>
                    </li>
                    <li>
                      <p>
                         Matches its description.
                      </p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p>
                    We must provide you with digital content that complies with your legal rights.
                  </p>
                </li>
                <li>
                  <p>
                    When we supply the digital content:
                  </p>
                  <ol style="list-style-type: lower-alpha;">
                    <li>
                      <p>
                        We will use all reasonable efforts to ensure that it is free from defects, viruses and other malicious content.
                      </p>
                    </li>
                    <li>
                      <p>
                         we do not promise that it is compatible with any third-party software or equipment except where we have said that it is in the guide to its use or on our website and
                      </p>
                    </li>
                    <li>
                      <p>
                          you acknowledge that there may be minor errors or bugs in it.
                      </p>
                    </li>
                  </ol>
                </li>
              </ol>
              <h5 class="content-heading">
                Nature of services
              </h5>
              <ol>
                <li>
                  <p>
                    You have certain legal rights (also known as 'statutory rights'), for example, that any services purchased are performed by us with reasonable care and skill.
                  </p>
                </li>
                <li>
                  <p>
                    We must provide you with services that comply with your legal rights.
                  </p>
                </li>
                <li>
                  <p>
                    When we supply services:
                  </p>
                  <ol style="list-style-type: lower-alpha;">
                    <li>
                      <p>
                        We will use all reasonable care and skill in the performance of those services
                      </p>
                    </li>
                    <li>
                      <p>
                         Where the price is not agreed beforehand, we will provide the service for a reasonable price and
                      </p>
                    </li>
                    <li>
                      <p>
                          We will perform the services within a reasonable time.
                      </p>
                    </li>
                  </ol>
                </li>
              </ol>
              <h5 class="content-heading">
                Faulty digital content/ Unsatisfactory Performance of Services
              </h5>
              <ol>
                <li>
                  <p>
                    Your legal rights (also known as 'statutory rights'), are set out at the top of this contract. They are a summary of your key rights. For more detailed information on your rights and what you should expect from us, please:
                  </p>
                  <p class="text-center">
                    contact us using the contact details at the top of this page or
                  </p>
                </li>
                <li>
                  <p>
                    Nothing in this contract affects your legal rights. You may also have other rights in law.
                  </p>
                </li>
                <li>
                  <p>
                    Please contact us using the contact details at the top of this page, if you want:
                  </p>
                  <ol style="list-style-type: lower-alpha;">
                    <li>
                      <p>
                        Us to repair the digital content.
                      </p>
                    </li>
                    <li>
                      <p>
                         Repeat performance of services purchased.
                      </p>
                    </li>
                    <li>
                      <p>
                          A price reduction or
                      </p>
                    </li>
                    <li>
                      <p>
                           To reject the digital content and get a refund.
                      </p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p>
                    To avoid faults happening with any digital content, you must:
                  </p>
                  <ol style="list-style-type: lower-alpha;">
                    <li>
                      <p>
                         Install any fixes, updates, upgrades, new releases and new versions that are made available to you as soon as reasonably possible after we tell you that they are available to be downloaded.
                      </p>
                    </li>
                    <li>
                      <p>
                         Use it only on the recommended third-party software and equipment set out in the guide to its use or on our website; and
                      </p>
                    </li>
                    <li>
                      <p>
                         Follow any other guidance given by us to you when undertaking the purchase, or contained within the Confirmation email.
                      </p>
                    </li>
                  </ol>
                </li>
              </ol>
              <h5 class="content-heading">
                End of the contract
              </h5>
              <p>
                If this contract is ended it will not affect our right to receive any money which you owe to us under this contract.
              </p>
              <h5 class="content-heading">
                Limit on our responsibility
              </h5>
              <ol>
                <li>
                  <p>
                    Except for any legal responsibility that we cannot exclude in law (such as for death or personal injury), we are not legally responsible for:
                  </p>
                  <ol style="list-style-type: lower-alpha;">
                    <li>
                      <p>
                        losses that:
                      </p>
                      <ol style="list-style-type: lower-roman;">
                        <li>
                          <p>
                            Were not foreseeable to you and us when the contract was formed; or
                          </p>
                        </li>
                        <li>
                          <p>
                            That were not caused by any breach on our part;
                          </p>
                        </li>
                      </ol>
                    </li>
                    <li>
                      <p>
                         Business losses and
                      </p>
                    </li>
                    <li>
                      <p>
                          losses to non-consumers.
                      </p>
                    </li>
                  </ol>
                </li>
              </ol>
              <h5 class="content-heading">
                Indemnity and insurance
              </h5>
              <ol>
                <li>
                  <p>
                    You shall indemnify us, and keep us indemnified, from and against any losses, damages, liability, costs (including legal fees) and expenses incurred by us as a result of or in connection with your breach of any of your obligations under this contract.
                  </p>
                </li>
                <li>
                  <p>
                    You shall have in place contracts of insurance with reputable insurers to cover your obligations under this contract. On request, you shall supply so far as is reasonable evidence of the maintenance of the insurance and all of its terms from time to time applicable.
                  </p>
                </li>
              </ol>
              <h5 class="content-heading">
                Limitation of liability
              </h5>
              <ol>
                <li>
                  <p>
                    The extent of the parties' liability under or in connection with this Contract (regardless of whether such liability arises in tort, contract or in any other way and whether or not caused by negligence or misrepresentation) shall be as set out in this clause.
                  </p>
                </li>
                <li>
                  <p>
                     Subject to the sub-clauses below (entitled 'Exceptions'), our total liability shall not exceed the sum of USD 10.00 (ten united states dollars).
                  </p>
                </li>
                <li>
                  <p>
                     Subject to sub-clauses below (entitled 'Exceptions'), we shall not be liable for consequential, indirect or special losses.
                  </p>
                </li>
                <li>
                  <p>
                    Subject to sub-clauses below (entitled 'Exceptions'), we shall not be liable for any of the following (whether direct or indirect):
                  </p>
                  <ol style="list-style-type: lower-alpha;">
                    <li>
                      <p>
                        loss of profit.
                      </p>
                    </li>
                    <li>
                      <p>
                        loss or corruption of data.
                      </p>
                    </li>
                    <li>
                      <p>
                        loss of use.
                      </p>
                    </li>
                    <li>
                      <p>
                        loss of production.
                      </p>
                    </li>
                    <li>
                      <p>
                        loss of contract.
                      </p>
                    </li>
                    <li>
                      <p>
                        loss of opportunity.
                      </p>
                    </li>
                    <li>
                      <p>
                        loss of savings, discount or rebate (whether actual or anticipated) or
                      </p>
                    </li>
                    <li>
                      <p>
                        harm to reputation or loss of goodwill.
                      </p>
                    </li>
                  </ol>
                </li>
                <p>
                  <strong>
                    Exception
                  </strong>
                </p>
                <li>
                  <p>
                     The limitations of liability set out above shall not apply in respect of any indemnities given by either party under this Contract.
                  </p>
                </li>
                <li>
                  <p>
                    Notwithstanding any other provision of this Contract, the liability of the parties shall not be limited in any way in respect of the following:
                  </p>
                  <ol style="list-style-type: lower-alpha;">
                    <li>
                      <p>
                        Death or personal injury caused by negligence.
                      </p>
                    </li>
                    <li>
                      <p>
                        Fraud or fraudulent misrepresentation.
                      </p>
                    </li>
                    <li>
                      <p>
                        Any other losses which cannot be excluded or limited by applicable law.
                      </p>
                    </li>
                    <li>
                      <p>
                        Any losses caused by wilful misconduct.
                      </p>
                    </li>
                  </ol>
                </li>
              </ol>
              <h5 class="content-heading">
                Rights of third parties
              </h5>
              <p>
                No one other than a party to these Terms has any right to enforce any of these Terms.
              </p>
              <h5 class="content-heading">
                Disputes
              </h5>
              <ol>
                <li>
                  <p>
                    We will try to resolve any disputes with you quickly and efficiently.
                  </p>
                </li>
                <li>
                  <p>
                    If you are unhappy with:
                  </p>
                  <ol style="list-style-type: lower-alpha;">
                    <li>
                      <p>
                         The services or digital content.
                      </p>
                    </li>
                    <li>
                      <p>
                        Our service to you or
                      </p>
                    </li>
                    <li>
                      <p>
                        Any other matter.
                      </p>
                    </li>
                  </ol>
                  <p>
                    please contact us as soon as possible.
                  </p>
                </li>
                <li>
                  <p>
                    If you and we cannot resolve a dispute using our complaint handling procedure, we will:
                  </p>
                  <ol style="list-style-type: lower-alpha;">
                    <li>
                      <p>let you know that we cannot settle the dispute with you; and</p>
                    </li>
                    <li>
                      <p>
                         give you certain legally required information about our alternative dispute resolution provider which is run by Dubai International Arbitration Centre at
                      </p>
                      <p>
                        Baniyas Road, Deira
                        <br>
                        P. O. Box 1457
                        <br>
                        Dubai, United Arab Emirates
                      </p>
                    </li>
                  </ol>
                  <p>
                    You may also use the online dispute resolution (ODR) platform to resolve the dispute with us. For more details, please visit the website on the 'Your Europe' portal: <a target="_blank" href="https://webgate.ec.europa.eu/odr/">https://webgate.ec.europa.eu/odr</a>.consider the need for Alternative Dispute Resolution and, if considered necessary, provide you with information about any alternative dispute resolution provider we deem appropriate to deal with your complaint.
                  </p>
                </li>
                <li>
                  <p>
                    If you want to take court proceedings, the relevant courts of the United Arab Emirates will have exclusive jurisdiction in relation to these Terms.
                  </p>
                </li>
                <li>
                  <p>
                    The laws of United Arab Emirates will apply to these Terms.
                  </p>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  created () {
    this.$store.commit('ISLOADING', false)
  }
}
</script>

<style>

.hero-image {
  position: relative;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  background-color: rgba(0,0,0,0.5);
}


.hero-image img {
  max-height: 500px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/tandcsales.vue